document.addEventListener('DOMContentLoaded', function() {
    const dropdowns = document.querySelectorAll('.dropdown-section .dropdown');
    
    dropdowns.forEach(dropdown => {
        const button = dropdown.querySelector('.dropbtn');
        const content = dropdown.querySelector('.dropdown-content');
        
        if (!button || !content) return;
        
        // Remove the content from its original parent and append to body
        const detachedContent = content.cloneNode(true);
        document.body.appendChild(detachedContent);
        content.remove(); // Remove original
        
        // Add styles to make it completely isolated
        detachedContent.style.position = 'fixed';
        detachedContent.style.zIndex = '559999';
        detachedContent.style.display = 'none';
        detachedContent.classList.add('hero-dropdown-detached');
        
        // Get the computed outline color from the button
        const buttonStyles = getComputedStyle(button);
        const outlineColor = buttonStyles.getPropertyValue('border-color') || getComputedStyle(dropdown.closest('.dropdown-section')).getPropertyValue('--outline-color') || '#97cc04';
        
        // Apply all the original styles directly
        detachedContent.style.backgroundColor = '#FBFBFB';
        detachedContent.style.border = `2px solid ${outlineColor}`;
        detachedContent.style.borderTop = 'none';
        detachedContent.style.maxHeight = '23rem';
        detachedContent.style.overflowY = 'auto';
        detachedContent.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
        
        // Style all the links inside
        const links = detachedContent.querySelectorAll('a');
        links.forEach((link, index) => {
            link.style.color = 'black';
            link.style.padding = '1rem 1.5rem';
            link.style.textDecoration = 'none';
            link.style.display = 'block';
            link.style.backgroundColor = 'transparent';
            
            // Add border bottom except for last item
            if (index < links.length - 1) {
                link.style.borderBottom = '2px solid #E5E5E5';
            }
            
            // Add hover effect
            link.addEventListener('mouseenter', () => {
                link.style.backgroundColor = '#FBF8F3';
            });
            link.addEventListener('mouseleave', () => {
                link.style.backgroundColor = 'transparent';
            });
        });
        
        let isOpen = false;
        let hideTimeout;
        
        function showDropdown() {
            clearTimeout(hideTimeout);
            
            // Get button position
            const rect = button.getBoundingClientRect();
            
            // Position the dropdown
            detachedContent.style.top = `${rect.bottom}px`;
            detachedContent.style.left = `${rect.left}px`;
            detachedContent.style.width = `${rect.width}px`;
            detachedContent.style.display = 'block';
            
            isOpen = true;
        }
        
        function hideDropdown() {
            hideTimeout = setTimeout(() => {
                detachedContent.style.display = 'none';
                isOpen = false;
            }, 100); // Small delay to prevent flickering
        }
        
        // Show on button hover
        button.addEventListener('mouseenter', showDropdown);
        button.addEventListener('mouseleave', hideDropdown);
        
        // Keep open when hovering over dropdown content
        detachedContent.addEventListener('mouseenter', () => {
            clearTimeout(hideTimeout);
        });
        detachedContent.addEventListener('mouseleave', hideDropdown);
        
        // Handle window resize to reposition
        window.addEventListener('resize', () => {
            if (isOpen) {
                const rect = button.getBoundingClientRect();
                detachedContent.style.top = `${rect.bottom}px`;
                detachedContent.style.left = `${rect.left}px`;
                detachedContent.style.width = `${rect.width}px`;
            }
        });
        
        // Handle scroll to reposition
        window.addEventListener('scroll', () => {
            if (isOpen) {
                const rect = button.getBoundingClientRect();
                detachedContent.style.top = `${rect.bottom}px`;
                detachedContent.style.left = `${rect.left}px`;
            }
        });
        
        // Close on outside click
        document.addEventListener('click', (e) => {
            if (isOpen && !button.contains(e.target) && !detachedContent.contains(e.target)) {
                hideDropdown();
            }
        });
    });
});